import { EmptyState, Screen, Text } from '~/atomic';
import { useAppDispatch, useAppSelector } from '~/store';
import {
  selectNotifications,
  selectUnreadCount,
} from '~/store/notifications/selectors';
import { notificationsMarkAllRead } from '~/store/notifications/slices';

const fmtDate = (iso: string) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default function NotificationView() {
  const dispatch = useAppDispatch();
  const { items } = useAppSelector(selectNotifications);
  const unread = useAppSelector(selectUnreadCount);

  return (
    <Screen
      headerTitle="Notificações"
      headerSubtitle={unread > 0 ? `${unread} não lidas` : 'Tudo em dia'}
      headerRightIcon={unread > 0 ? 'icon-check' : undefined}
      onClickHeaderRight={() => dispatch(notificationsMarkAllRead())}
    >
      <div className="flex flex-col gap-smaller py-medium">
        {items.length === 0 ? (
          <EmptyState
            icon="icon-notification"
            title="Sem notificações"
            description="Você verá aqui alertas das suas parcelas e contratos."
          />
        ) : (
          items.map((n) => (
            <div
              key={n.id}
              className="flex flex-col gap-quark p-small rounded-small bg-intense-01 border border-intense-03"
            >
              <div className="flex items-center justify-between">
                <Text className="text-paragraphMD color-complement-01">{n.title}</Text>
                {!n.read ? (
                  <span className="h-[8px] w-[8px] rounded-full bg-primary-01" />
                ) : null}
              </div>
              <Text className="text-bodySM color-intense-06">{n.description}</Text>
              <Text className="text-captionMD color-intense-05">
                {fmtDate(n.createdAt)}
              </Text>
            </div>
          ))
        )}
      </div>
    </Screen>
  );
}
